<template>
  <div class="main">
    <report-top> </report-top>
    <selectTool ref="selectTool">
      <div class="selectToolItem" slot="item">
        <Button @click="getSearchItem" type="primary" class="chaxun"
          >立即分析</Button
        >
      </div>
    </selectTool>
    <div id="temp_wrap">
      <draw ref="draw"></draw>
      <table-list ref="tableList"></table-list>
    </div>
  </div>
</template>
<script>
import draw from "./draw.vue";
import tableList from "./tableList.vue";

export default {
  components: { draw, tableList },
  data() {
    return {
      searchItem: {
        deviceNo: "",
        carNo: "",
        //pageSize: 50, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
        endTime: "",
        startTime: "",
        //pageNumber: 1,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        },
        {
          title: "选择车辆",
          key: "deviceIdList",
          type: "selectAlotCar",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/assay/refuel",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        console.log(data);
        this.$refs.tableList.reachData(data);
        this.$refs.draw.reachData(data);

      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    search() {
      console.log(this.keyWork);
      this.reset();
      this.getList();
    },
    exportAll() {
      if (this.searchItem.deviceNo.length == 0) {
        this.$Message.error("信息不完整");
        return;
      }
      var a = this.$refs.startEnd.getTimeObj();
      this.searchItem.startTime = a.start;
      this.searchItem.endTime = a.end;
      var params = [
        {
          name: "deviceNo",
          value: this.searchItem.deviceNo,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
        {
          name: "returnCoord",
          value: 2,
        },
      ];

      this.utils.exportData(this.axios.lbs + "/temp/export", params);
    },
    reset() {},
  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style lang="">
#temp_wrap {
  width: 100%;
  height: calc(100% - 100px);
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/jiayou/index.vue